import React from 'react';
import './Reports.css';

const Reports = () => {
  return (
    <div className="reports-container">
      <div className="development-message">
        <h2>Reports</h2>
        <p>Development in progress</p>
      </div>
    </div>
  );
};

export default Reports;
